import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadSceneEvent, WarsEvents, WarsScenes } from "@playroomkit/pr-wars/events";
import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import "./Footer.css";
import { platform } from "@playroomkit/pr-common";
import { utils } from "@playroomkit/pr-wars/utils";

interface FooterProps {
  version: string;
}

const Footer: React.FC<FooterProps> = ({ version }) => {
  const { t } = useTranslation(["main"]);
  const [showPublisherIcons, setShowPublisherIcons] = useState(true);

  useEffect(() => {
    const handleLoadSceneEvents = (event: Event) => {
        let e = event as LoadSceneEvent,
            display: boolean = e.sceneName === WarsScenes.Title;
        setShowPublisherIcons(!!display);
      }
    document.addEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvents);
    return () => {
      document.removeEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvents);
    }
  }, [])

  if (!showPublisherIcons) {
    return <></>
  }
  return (
      <View>
        <ScalableWrapper anchor='bottom-left' lockOrientation="auto" maintainAspectRatioBy="height">
          <View className="footer-container footer-content items-end hidden md:flex">
              {!utils.isRunningInMobile() &&
                <>
                  <img
                    src="img/Logos/esrb.webp"
                    alt="Studio Logo"
                    className="esrb-logo invisible md:visible mb-1"
                  />
                  <img
                    src="img/Logos/party-games.webp"
                    alt="Powered By Playroom Logo"
                    className="party-games-logo invisible md:visible mb-1"
                  />
                </>
              }
            <p className="uppercase mb-4 ml-1">
              <a href="https://joinplayroom.com/games/terms/thelastshow/tos-tls.txt" target="_blank" rel="noopener noreferrer"> {t('terms')} </a> | <a href="https://joinplayroom.com/games/terms/privacy.txt" target="_blank" rel="noopener noreferrer"> {t('policy')} </a> | {t('built')}: {version}
            </p>
          </View>
        </ScalableWrapper>
        { !platform.isRunningInDiscord ? 
        <ScalableWrapper anchor='bottom-right'  maintainAspectRatioBy="height">
          <View className="footer-container justify-end invisible md:visible available-on-discord ">
            <a href="https://discord.com/activities/1294399938553319485?referrer_id=1216985806237991013"  target="_blank" rel="noopener noreferrer">
            <img
              src="img/UI/available_on_discord.webp"
              alt="available on discord"
              className="mr-12 mb-2 lg:mr-3"
            />
            </a>
          </View>
        </ScalableWrapper>
        : null }
      </View>
  );
};

export default Footer;
